import { render } from "./KnowledgeInfoSet.vue?vue&type=template&id=a0aa4daa"
import script from "./KnowledgeInfoSet.vue?vue&type=script&lang=js"
export * from "./KnowledgeInfoSet.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__